<div [ngClass]="{
	loading: !options || !options?.length
}">
	<div class="filter-box" *ngIf="options?.length > numResultsShown">
		<input type="text" #facetSearchInput autofocus [(ngModel)]="facetSearch" (input)="filterValues()"/>
		<i class="fa fa-times close-icon" (click)="facetSearch='';filterValues()" [hidden]="facetSearch===''"></i>
	</div>
	<div class="num-results" *ngIf="options?.length > numResultsShown && filteredOptions && filteredOptions?.length > 0">
		{{ 'RESULT_COUNTER' | translate: {start: 1, end: filteredOptions?.length, total: totalNumber } }}
	</div>
	<ul>
		<li *ngFor="let option of filteredOptions">
			<label>
				<bb-check [checked]="this.value.indexOf(option.value) > -1" (onChanged)="optionChecked(option.value, $event)"></bb-check>
				<span class="text" [ngClass]="{'not-set': option.label === ''}" *ngIf="!isAsyncValue(option.label)">{{ option.label ? valueLabelMap[option.label] || option.label : ( 'EMPTY' | translate ) }}</span>
				<span class="text" [ngClass]="{'not-set': option.label === ''}" *ngIf="isAsyncValue(option.label)">{{ (valueLabelMap[option.label] || option.label) | async }}</span>
				<span class="amount" [hidden]="(!option.amount && option.amount !== 0) || facetsLoading ">{{option.amount | number}}</span>
				<span class="amount" [hidden]="!facetsLoading">...</span>
			</label>
		</li>
	</ul>
	<div class="no-results" *ngIf="filteredOptions && filteredOptions?.length === 0">{{ 'NO_RESULTS_FOUND' | translate }}</div>
	
	<div class="show-more-results" *ngIf="options?.length > numResultsShown && filteredOptions && filteredOptions?.length > 0" (click)="numResultsShown = numResultsShown * 2; filterValues()">
		{{ 'SHOW_MORE' | translate }}
	</div>
	<bb-loading [size]="60" style="left: calc(50% - 30px)" *ngIf="facetsLoading"></bb-loading>
</div>